import React from 'react';
import { motion } from 'framer-motion';
export function OpeningLead() {
  return <section className="py-20 md:py-32 bg-ink relative" data-id="element-427">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl text-center" data-id="element-428">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-8" data-id="element-429">
          <p className="text-xl md:text-2xl text-cream font-light leading-relaxed" data-id="element-430">
            Hay un momento en cada celebración que nadie puede planear.
          </p>

          <p className="text-xl md:text-2xl text-cream font-light leading-relaxed" data-id="element-431">
            Es ese segundo en que tu mamá te abraza sin decir nada.
          </p>

          <p className="text-xl md:text-2xl text-cream font-light leading-relaxed" data-id="element-432">
            O cuando tu hija te mira con los ojos llenos de lágrimas antes de su
            primer vals.
          </p>

          <p className="text-xl md:text-2xl text-cream font-light leading-relaxed" data-id="element-433">
            O cuando la abuela — la que viajó desde lejos, la que no sabías si
            iba a poder venir — te toma de la mano y te dice:{' '}
            <span className="font-serif italic" data-id="element-434">
              "Qué orgullosa estoy de ti."
            </span>
          </p>

          <p className="text-2xl md:text-3xl font-serif text-gold pt-4" data-id="element-435">
            Ese momento dura tres segundos.
          </p>

          <p className="text-xl md:text-2xl text-cream font-light leading-relaxed" data-id="element-436">
            Y si no lo capturas… desaparece para siempre.
          </p>

          <div className="py-6 space-y-4 text-cream/80" data-id="element-437">
            <p data-id="element-438">
              No lo encontrarás en las fotos del fotógrafo — que las entrega
              tres semanas después en un Google Drive que la mitad de la familia
              no sabe cómo abrir.
            </p>
            <p data-id="element-439">
              No estará en los videos de Instagram — que se ven una vez y se
              olvidan entre memes y reels.
            </p>
            <p data-id="element-440">
              No aparecerá en el álbum digital — que prometiste imprimir y que
              sigue pendiente dos años después.
            </p>
          </div>

          <p className="text-xl md:text-2xl text-cream font-light leading-relaxed" data-id="element-441">
            El tiempo pasa. Los eventos terminan. Y lo que queda son los
            recuerdos.
          </p>

          <p className="text-xl md:text-2xl text-cream font-medium leading-relaxed" data-id="element-442">
            ¿Pero cuántos recuerdos reales — tangibles, físicos, que se puedan
            tocar — tienes de los eventos más importantes de tu vida?
          </p>

          <div className="pt-8" data-id="element-443">
            <p className="font-script text-5xl md:text-6xl text-gold" data-id="element-444">
              Pero nosotros sí.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}